"use client";

import ErrorComponent from "@/components/Error";
import { notifyError } from "@/utils/monitoring";
import { useEffect } from "react";

export default function ErrorPage({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    notifyError(error, "appError");
  }, [error]);

  return <ErrorComponent reset={reset} />;
}
